import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tick",
  "use": "icon-tick-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 9\" id=\"icon-tick\"><path d=\"M11 2.2L4.3 9 0 4.6l2.1-2.1 2.2 2.2L8.9 0 11 2.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol